import apiDocument from '../../api/document';
import { Base64Decode } from '@/util/base64';
import { marked } from 'marked/lib/marked.esm.js';
import _assign from 'lodash/assign';
import _first from 'lodash/first';
import _last from 'lodash/last';
import _map from 'lodash/map';
import _forEach from 'lodash/forEach';
import _includes from 'lodash/includes';

function getMenus(text) {
  return marked
    .lexer(text)
    .filter(content => content.type === 'heading')
    .filter(content => content.depth < 4)
    .map((content, id) =>
      _assign(content, {
        id
      })
    );
}

function assembleToMenus(list) {
  return _map(list, (content, index) => {
    const contents = content.split('/');
    const first = contents[0];
    const second = contents[1];
    const suffix = '.md';
    let menu = {
      type: 'heading',
      id: index,
      request: true
    };
    if (second) {
      // have folder
      const suffixIndex = second.lastIndexOf(suffix);
      const text = second.substr(0, suffixIndex);
      menu.depth = 2;
      menu.text = text;
      menu.full = content;
    } else {
      let text = first;
      const hasMdSuffix = first.indexOf(suffix) !== -1;
      if (hasMdSuffix) {
        const suffixIndex = text.lastIndexOf(suffix);
        text = text.substr(0, suffixIndex);
        menu.full = content;
      }
      menu.depth = 1;
      menu.text = text;
    }
    menu.text = _last(menu.text.split('.'));
    return menu;
  });
}

function calcParentMenus(list) {
  let contents = [];
  list.sort((a, b) => {
    a = _first(a.split('.'));
    b = _first(b.split('.'));
    return parseInt(a) - parseInt(b);
  });
  _forEach(list, value => {
    const values = value.split('/');
    const first = _first(values);
    const last = _last(values);
    if (!last) {
      return;
    }
    if (!_includes(contents, first)) {
      contents.push(first);
    }
    if (!_includes(contents, value)) {
      contents.push(value);
    }
  });
  return contents;
}

function sortReverse(arr) {
  return arr.slice().sort(reverse);
}

function reverse(a, b) {
  return versionToNum(b.version) - versionToNum(a.version);
}

function versionToNum(value) {
  value = value.split('-')[0]; // 0.1.1-alpha
  value = value.split(' ')[0]; // 0.1.1 alpha
  let a = value.toString();
  let c = a.split('.');
  let numPlace = ['', '0', '00', '000', '0000'],
    r = numPlace.reverse();
  for (let i = 0; i < c.length; i++) {
    let len = c[i].length;
    c[i] = r[len] + c[i];
  }
  let res = c.join('');
  return res;
}

function changeMarkdownImgUrls(text, device, version) {
  let content = text;
  if (device !== 'web') {
    const urls = content.match(/[^'"(]*\.(?:png|jpe?g)/gi);
    const urlInfo = _map(urls, url => {
      return {
        old: url,
        new:  device === 'ios' || device === 'android'
            ? `https://map-service.mapxus.com/dpw/api/v1/image/digitalMap/${device}/${version}/${_last(url.split('/'))}`
            : device === 'rn'
                ? `https://map-service.mapxus.com/dpw/image/digitalMap/rn/${_last(url.split('/'))}`
                : url
      };
    });
    _forEach(urlInfo, info => {
      content = content.replace(info.old, info.new);
    });
  }
  return content;
}

const state = {
  menus: [],
  content: '',
  type: '',
  device: '',
  versions: [],
  isLoading: true,
  backToTop: false
};

const getters = {
  getFirstVersion(state) {
    return _first(sortReverse(state.versions));
  },
  getVersions(state) {
    return sortReverse(state.versions);
  },
  getFirstMenu(state) {
    return state.menus;
  }
};

const actions = {
  getDocumentByPath({ commit, state }, { version, path }) {
    apiDocument
      .getDocumentByVersion(state, version, path)
      .then(res => res.text())
      .then(text => {
        const content = changeMarkdownImgUrls(Base64Decode(text), state.device, version);
        commit('setContent', content);
      });
  },
  getDocumentByVersion({ commit, state }, { version }) {
    apiDocument
      .getDocumentByVersion(state, version)
      .then(res => res.text())
      .then(text => {
        const content = changeMarkdownImgUrls(Base64Decode(text), state.device, version);
        commit('setDocument', content)
      });
  },
  getMenusFullPathByVersion({ commit, state }, { version }) {
    apiDocument
      .getMenusFullPathByVersion(state, version)
      .then(res => res.json())
      .then(json => commit('setMenus', json));
  },
  getVersions({ commit, state }) {
    apiDocument
      .getVersions(state)
      .then(res => res.json())
      .then(json => commit('setVersions', json.length ? json : []));
  },
  setType({ commit }, type) {
    commit('setType', type);
  },
  setDevice({ commit }, device) {
    commit('setDevice', device);
  },
  setVersions({ commit }, versions) {
    commit('setVersions', versions.slice());
  },
  setLoading({ commit }, isLoading) {
    commit('setLoading', isLoading);
  },
  backToTop({ commit }) {
    commit('backToTop');
  }
};

const mutations = {
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setDocument(state, text) {
    state.menus = getMenus(text);
    state.content = marked.parse(text);
  },
  setContent(state, text) {
    state.content = marked.parse(text);
  },
  setMenus(state, menus) {
    state.menus = assembleToMenus(calcParentMenus(menus));
  },
  setType(state, type) {
    state.type = type;
  },
  setDevice(state, device) {
    state.device = device;
  },
  setVersions(state, versions) {
    state.versions = versions;
  },
  backToTop(state) {
    state.backToTop = true;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
